
import './About.css';

const About = () => {


  return (
    <div className="about">
        Coming soon...
    </div>
  );
};

export default About;
